// sign_utils.js

import CryptoJS from 'crypto-js';
import forge from 'node-forge';
const NodeRSA = require('node-rsa');

// 公钥 PEM
const publicPem = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAudfmoQCPSsAfTycl8iYs
zU0SOCq9/Txbx1F9DSwpO8zGv7ZMGpAMX8bMVQcvbX9eSZiOnjZZL6nu/7zP3Tis
WqQ19EL+BiN7TSN8VXNJlhC65GPUFyXJ9/Tewzfxljb3BeAPv6rRciGu5WnGQIBl
d5yrbUPTE3orX1I63536Kd0A4pnEe4zeaESFgQpw3tpav2kZtas4JQ+ybExtwmc9
DcwurDg7SqxccUgVpAjmgtAHDhQmDGN+q1WnE6J8uU7DaQDkGtFNiQtwcctYCak5
9aZBsYJ/+SSiYbnogyQVMSX+m0eMJcBonvtsJo3RpQeKkuUd8cmLOeMol1/lGHSO
IQIDAQAB
-----END PUBLIC KEY-----`;

const privatePem = `-----BEGIN RSA PRIVATE KEY-----
MIIEpAIBAAKCAQEAudfmoQCPSsAfTycl8iYszU0SOCq9/Txbx1F9DSwpO8zGv7ZM
GpAMX8bMVQcvbX9eSZiOnjZZL6nu/7zP3TisWqQ19EL+BiN7TSN8VXNJlhC65GPU
FyXJ9/Tewzfxljb3BeAPv6rRciGu5WnGQIBld5yrbUPTE3orX1I63536Kd0A4pnE
e4zeaESFgQpw3tpav2kZtas4JQ+ybExtwmc9DcwurDg7SqxccUgVpAjmgtAHDhQm
DGN+q1WnE6J8uU7DaQDkGtFNiQtwcctYCak59aZBsYJ/+SSiYbnogyQVMSX+m0eM
JcBonvtsJo3RpQeKkuUd8cmLOeMol1/lGHSOIQIDAQABAoIBACavoWRRlAKZBMt6
2ETUmo3wJcNIbn1JM8fFmFUGJN08bwEYhzYeV10WqpFmqgJOucdzOPkJUj6ATu6w
lMq10fcaaNrcmTmY6EFyCh9VnPNerzD88PkSlj0GHdsgiatd7MUt08lv2yK5jUlX
X/wsXjLsi6j2rflHfMDegr/rCFjvO8avES5JIeAr+SgEa/dcpCkWdYyL3IFrhn8j
bq7FmpQCSG1nL7MVmsxjCpjiZVcuOOUKJR9b80CweaSxuYRAuEobHG/JGaPpXDny
wY83OcVet4BbmLaHN1JIaF++e+5EEDCRpF4y3L1D3pjURSeQtqE7+9wGwUN/IFgt
3MTRufkCgYEA8ahrYhh+kKVl3gaAUuh+3kJWabEbMoag7/ZP8TARJ3N2BRXauopi
OVFjGIhTdbTJUI4edjw5hxYoJOg3TJVe7kbYwRGLKPWfEvzm9+vtTrWU6L67FHX4
JiDTLJV6Ihrq1mzitwv/r9i+6pTCk82UF++IY5iaBhji+kQVgWZ+0f0CgYEAxN95
gxjOhNSYlHhS5GyCK3BPhVF2ePrqMlWGO89mtoAT5TuWhKPHr5bd7IyzoCgT5zfM
cEGiREgWWxHdB9pC7pwq/2m79anWg/TU2OzPAzFFmceW+iHx4EU46XfJFiwocJer
Bg+pkSsuFoCxNKGR7+UOU5KpC58cua+7X7HgI/UCgYA846PS/rr9NT+alubEfSJi
XDKrxN1GeNeaPuTbr7HSz+vf0ibfs7iWGqSubMMiuF+1NWoFfp08JWAOFJjCaiyW
OzGoTARVWLYxMZn8w+xyVZxknJJE0IirCsBKzosMht2/E4Z4esR9CU7pinwQg88Z
zNf/yFaezKx8RKVqimnP/QKBgQCUxRsZygElt1GlwFdDbgvfr3soD6srONEJQD+z
qsK/XoGqVCEmEm2vbp49RwXmHOMNcsj2e2KXnrHmF9WjPXgev7xuTgRPXAxSowzE
8A5vJyilUIHyevxAsY6UPoSiULQugS4n4mYM4UhukMlYMFALrFfrJ4S+13nph7Zc
Vho+kQKBgQDJFqA9+Eq7wGr+pkCPdzmc0q4cRGHPxyYhW9x8JOcBtDgyh449WCHK
QvHIJ3O/mmuIFVHvuqnEphZ37xUnCd4lk+vNjk7z1TcTn/NJ1SnDeSpqXs2/4Ptx
Q1y6gudjWDdnbofBTijo9ukHQQybxEh6glOY4aXFj44/xOFTuf022A==
-----END RSA PRIVATE KEY-----`;

// 最大加密块大小
const MAX_ENCRYPT_BLOCK = 245;
const MAX_DECRYPT_BLOCK = 256;

/**
 * 生成签名
 * @param {Object} body - 要签名的数据对象
 * @param {Number} timestamp - 时间戳
 * @returns {String} 生成的 MD5 签名
 */
export function generateSignature(body, timestamp) {
  // 使用传统方式合并对象
  const map = Object.assign({}, body);
  map['api-time'] = timestamp; // 添加时间戳字段

  const keys = Object.keys(map).sort();
  let str = '';

  keys.forEach((key, index) => {
    str += `${index === 0 ? '' : '&'}${key}=${map[key]}`;
  });

  // 加入密钥
  str += '&key=Sru22*7f7F!fGG';

  // 生成 MD5 签名并返回
  return CryptoJS.MD5(str).toString().toUpperCase();
}

/**
 * 使用公钥分段加密
 * @param {String} content - 要加密的内容
 * @returns {Promise<String>} 加密后的内容
 */
export async function rsaEncryptWithPublicKey(content) {
  const publicKey = forge.pki.publicKeyFromPem(publicPem);
  const contentBytes = forge.util.encodeUtf8(content);
  let encryptedParts = [];

  // 分段加密
  for (let i = 0; i < contentBytes.length; i += MAX_ENCRYPT_BLOCK) {
    const segment = contentBytes.slice(i, i + MAX_ENCRYPT_BLOCK);
    const encrypted = publicKey.encrypt(segment, 'RSAES-PKCS1-V1_5');
    encryptedParts.push(forge.util.encode64(encrypted)); // 将加密结果转换为 base64
  }
  return encryptedParts.join('|');
}

/**
 * 使用私钥分段解密
 * @param {String} encryptedContent - 要解密的内容
 * @returns {Promise<String>} 解密后的内容
 */
export async function rsaDecryptWithPrivateKey(encryptedContent) {
  const privateKey = forge.pki.privateKeyFromPem(privatePem);  // 私钥用于解密
  const encryptedParts = encryptedContent.split('|');  // 分割多个加密段
  let decryptedBytes = '';

  // 分段解密
  for (const part of encryptedParts) {
    const segmentBytes = forge.util.decode64(part);  // Base64 解码
    try {
      // 使用私钥解密
      decryptedBytes += privateKey.decrypt(segmentBytes, 'RSAES-PKCS1-V1_5');
    } catch (error) {
      console.error("Error decrypting:", error);
      throw new Error("Decryption failed");
    }
  }

  return forge.util.decodeUtf8(decryptedBytes);  // 转换为 UTF-8 字符串
}

/**
 * 使用公钥分段解密，假设后端是使用私钥加密
 * @param {String} encryptedContent - 要解密的内容（已经 Base64 编码）
 * @returns {Promise<String>} 解密后的内容
 */
export async function rsaDecryptWithPublicKey(encryptedContent) {
  // 使用公钥创建 RSA 实例
  const key = new NodeRSA(publicPem);

  key.setOptions({encryptionScheme: 'pkcs1'});

  // 将加密内容分成多个块，假设是通过 " | " 分隔的
  const encryptedParts = encryptedContent.split('|');

  let decryptedBytes = '';

  // 逐个分段解密
  for (const part of encryptedParts) {
    const segmentBytes = Buffer.from(part, 'base64'); // Base64 解码
    try {
      // 使用公钥进行解密
      const decryptedPart = key.decryptPublic(segmentBytes, 'utf8'); // 解密并转为字符串
      decryptedBytes += decryptedPart;
    } catch (error) {
      console.log("Error decrypting:", error);
    }
  }

  return JSON.parse(decryptedBytes); // 返回解密后的内容
}





// WEBPACK FOOTER //
// ./src/utils/sign_utils.js